export type TranslationRow = {
  id: string;
  language: string; // e.g., "HI"
  source_text: string; // e.g., "welcome" or "form.name"
  translated_text: string; // e.g., "आपके डैशबोर्ड में स्वागत है"
  tenant_id?: string;
  is_active?: boolean;
};

type ToResourceOptions = {
  useDotNotation?: boolean; // default: true
  skipInactive?: boolean; // default: true
  trim?: boolean; // default: true
};

function setDeep(target: Record<string, any>, path: string[], value: any) {
  let curr = target;
  for (let i = 0; i < path.length - 1; i++) {
    const key = path[i];
    if (!(key in curr) || typeof curr[key] !== "object" || curr[key] === null) {
      curr[key] = {};
    }
    curr = curr[key];
  }
  curr[path[path.length - 1]] = value;
}

/**
 * Convert DB translation rows to an i18n resource object
 */
export function toI18nResource(
  rows: TranslationRow | TranslationRow[],
  opts: ToResourceOptions = {}
): Record<string, any> {
  const { useDotNotation = true, skipInactive = true, trim = true } = opts;

  const list = Array.isArray(rows) ? rows : [rows];
  const out: Record<string, any> = {};

  for (const r of list) {
    if (!r) {
      continue;
    }
    if (skipInactive && r.is_active === false) {
      continue;
    }

    let key = r.source_text ?? "";
    let val = r.translated_text ?? "";

    if (trim) {
      key = key.trim();
      val = typeof val === "string" ? val.trim() : val;
    }

    if (!key) {
      continue;
    } // skip empty keys

    if (useDotNotation && key.includes(".")) {
      setDeep(out, key.split(".").filter(Boolean), val);
    } else {
      out[key] = val;
    }
  }

  return out;
}
